//# sourceMappingURL=my-weekday.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydaterangepicker/dist/interfaces/my-weekday.interface.js
// module id = 886
// module chunks = 9